import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip, Typography } from 'antd';

import {
  getIntegrationStatusView,
  getIntegrationSubStatusText,
} from '../data/statusViews';

import type { FC } from 'react';

import './IntegrationStatus.desktop.scss';

const { Text } = Typography;

export interface IntegrationStatusProps {
  status: string | null;
  /** Текст ошибки интеграции — расшифровывается в подсказке статуса «Ошибка» */
  errorMessage?: string | null;
  /**
   * Шаг входа, которого ждёт провайдер (challenge_required и подобные).
   * Канал при этом остаётся в статусе «Работает», поэтому без подписи строка
   * выглядит здоровой, хотя от человека требуется действие (issue/11031).
   */
  subStatus?: string | null;
}

export const IntegrationStatus: FC<IntegrationStatusProps> = ({
  status,
  errorMessage = null,
  subStatus = null,
}) => {
  const { label, hint } = getIntegrationStatusView(status, errorMessage);
  const subStatusText = getIntegrationSubStatusText(subStatus);

  return (
    <span className="integration-status">
      <span
        className={`integration-status__label integration-status__${
          status ?? 'unknown'
        }`}
      >
        <Tooltip title={hint}>
          {label} <QuestionCircleOutlined />
        </Tooltip>
      </span>
      {Boolean(subStatusText) && (
        <Text type="warning" className="integration-status__sub">
          {subStatusText}
        </Text>
      )}
    </span>
  );
};
